import SALE_TYPES from "../../dictionaries/saleTypes.json";
import SaleTypeIndicator from "../SaleTypeIndicator";
import BaseTag from "./BaseTag";

const SaleTypeTag = (props) => (
  <BaseTag
    icon={
      <SaleTypeIndicator
        className="saleType"
        sx={{ marginRight: 0 }}
        value={props.value}
      />
    }
    label={SALE_TYPES[props.value]?.name}
  />
);

export default SaleTypeTag;
